import {
  UNLOAD_VENUE_FINANCIALS,
  VENUE_FINANCIALS_ERROR,
  VENUE_FINANCIALS_RECEIVED,
  VENUE_FINANCIALS_REQUEST,
} from "./types";

let initialState = {
  loadingVenueFinancials: false,
  venueFinancials: null,
  venueFinancialsError: null,
};

export const venueFinancials = (state = initialState, action) => {
  switch (action.type) {
    case VENUE_FINANCIALS_REQUEST:
      return {
        ...state,
        loadingVenueFinancials: true,
        venueFinancialsError: null,
      };

    case VENUE_FINANCIALS_RECEIVED:
      return {
        ...state,
        loading: false,
        venueFinancials: action.data,
        venueFinancialsError: null,
      };

    case VENUE_FINANCIALS_ERROR:
      return {
        ...state,
        loading: false,
        venueFinancialsError: action.error,
      };

    case UNLOAD_VENUE_FINANCIALS:
      return initialState;

    default:
      return state;
  }
};
